import { SagaIterator } from 'redux-saga';
import { put, select, takeLatest } from 'redux-saga/effects';

import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { UpdateDisplayModeRequest } from '../../ts/ServerApi/requests/UpdateDisplayModeRequest';
import { ServerService } from '../../ts/services/ServerService';
import { UpdateExplorerDisplayMode } from '../actions/AppActionTypes';
import { UpdateExplorerDisplayModeAction, updateExplorerDisplayModeInternal } from '../actions/DisplaySettingsActions';
import { requestFailed } from '../actions/RequestFailedAction';
import * as DisplaySettingsUrlBindings from '../content/DisplaySettingsUrlBindings';
import { selectDisplaySettings } from '../selectors/DisplaySettingsSelectors';
import { ServiceLocator } from '../ServiceLocator';
import { DisplaySettings } from '../state/DisplaySettingsState';

export function* rootDisplayModeSaga(): SagaIterator {
  yield takeLatest(UpdateExplorerDisplayMode, handleUpdateDisplayMode);
}

export function* handleUpdateDisplayMode(action: UpdateExplorerDisplayModeAction): SagaIterator {
  try {
    const currentDisplaySettings: DisplaySettings = yield select(selectDisplaySettings);
    const currentDisplayMode = currentDisplaySettings.explorerDisplayMode;

    if (action.saveToServer && action.explorerDisplayMode !== currentDisplayMode) {
      saveDisplayModeToServer(action);
    }

    saveDisplayModeToUrl(action);

    // Make the update in the state
    yield put(updateExplorerDisplayModeInternal(action.explorerDisplayMode));

  } catch (e) {
    yield put(requestFailed(Messages.errorUnknown()));
  }
}

export function saveDisplayModeToServer(action: UpdateExplorerDisplayModeAction) {
  const ServerService = ServiceLocator.get<ServerService>('ServerService');
  ServerService.sendRequest(new UpdateDisplayModeRequest({ displayMode: action.explorerDisplayMode }));
}

export function saveDisplayModeToUrl(action: UpdateExplorerDisplayModeAction) {
  const queryString = getQueryStringServiceFromAngular();
  if (queryString()[DisplaySettingsUrlBindings.DisplayModeUrlKey]) {
    queryString(DisplaySettingsUrlBindings.DisplayModeUrlKey, action.explorerDisplayMode);
  }
}
